module.exports = __webpack_public_path__ + "img/9788998229412.4c182c78.jpg";